import axios from 'axios'

const Authorization = 'Authorization'

export const authToken = async (email, password) => {
  const url = '/v1/auth-token/'
  try {
    const response = await axios.post(url, { email, password })
    axios.defaults.headers.common[
      Authorization
    ] = `token ${response.data.token}`
    return response
  } catch (error) {
    throw error
  }
}

export const login = async (email, password) => {
  const url = '/v2/auth/web_login/'
  try {
    return await axios.post(url, { email, password })
  } catch (error) {
    throw error
  }
}

export const logout = async () => {
  const url = '/v2/auth/web_logout/'
  try {
    return await axios.post(url, {})
  } catch (error) {
    throw error
  }
}

export const logoutPreExistingUser = async (
  loggedInUserEmail,
  applicantEmail
) => {
  if (loggedInUserEmail && loggedInUserEmail !== applicantEmail) {
    try {
      await logout()
    } catch (e) {
      // tslint:disable-next-line:no-console
      console.warn(e)
    }
  }
}
